import configDev from "./config/dev";
import configSit from "./config/sit";
import configUat from "./config/uat";
import configPreprod from "./config/preprod";
import configProd from "./config/prod";

const appEnvironment = process.env["REACT_APP_ENVIRONMENT"] || "prod";
const SALT_NUMBER = 782561411;

export const environment = {
  appInfo: {
    buildNo: "41",
    version: "3.4.8",
    environment: appEnvironment,
  },
  apiInfo: {
    baseUrlGtPortal:
      process.env["REACT_APP_BASE_URL_GT_PORTAL"] || "https://apigw.generali.co.th/api-gt-portal/v1",
    authBasePath: `${process.env["REACT_APP_BASE_URL_AUTH"] || "https://apigw.generali.co.th/api-gt-portal/oauth/v1"}`,
    timeout: 30000,
    calibrateNumber: SALT_NUMBER,
  },
  integrationConfig: { genEzeLogin: "" },
  cognito: {
    logoutUri: "",
  },
};

const getAWSConfig = (env: string): any => {
  switch (env) {
    case "sit":
      environment.integrationConfig = configSit.integrationConfig;
      environment.cognito.logoutUri = configSit.logoutUri;
      return configSit.awsConfig;
    case "uat":
      environment.integrationConfig = configUat.integrationConfig;
      environment.cognito.logoutUri = configUat.logoutUri;
      return configUat.awsConfig;
    case "preprod":
      environment.integrationConfig = configPreprod.integrationConfig;
      environment.cognito.logoutUri = configPreprod.logoutUri;
      return configPreprod.awsConfig;
    case "prod":
      environment.integrationConfig = configProd.integrationConfig;
      environment.cognito.logoutUri = configProd.logoutUri;
      return configProd.awsConfig;
    default:
      environment.integrationConfig = configDev.integrationConfig;
      environment.cognito.logoutUri = configDev.logoutUri;
      return configDev.awsConfig;
  }
};

export const awsConfig = getAWSConfig(environment.appInfo.environment);
